const conditionError = 'ConditionError'

export function isConditionError(errorName?: string): boolean {
  return errorName === conditionError
}
